import { v4 as uuidv4 } from "uuid";

export const MAX_FILES_COUNT = 10;

interface IFile {
  url: string;
  uploadProgress: number;
  file: File;
  id: string;
}

export const addFiles = async (prevFiles: IFile[], newFiles: FileList) => {
  const files = [...prevFiles];

  for await (const file of newFiles) {
    if (files.length >= MAX_FILES_COUNT) {
      break;
    }

    files.push(await getUploadFile(file));
  }

  return files;
};

const getUploadFile = async (file: File): Promise<IFile> => {
  const dataUrl = await getDataURL(file);

  return {
    url: dataUrl,
    uploadProgress: 0,
    file,
    id: uuidv4()
  };
};

const getDataURL = (file: File): Promise<string> => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result as string), false);
    reader.readAsDataURL(file);
  });
};
